<span class="aum-expansion-panel-dragging-holder">
    <ng-content select="aum-expansion-panel-dragging-holder"></ng-content>
</span>
<span class="aum-expansion-index-viewholder">
    <span class="aum-expansion-index">
        <ng-content select="aum-panel-index"></ng-content>
    </span>
</span>
<span class="mat-content">
    <ng-content select="aum-panel-title"></ng-content>
    <aum-expansion-panel-information-i (emitInformationData)="onEmitInformationData($event)">
        <ng-content select="aum-panel-information"></ng-content>
    </aum-expansion-panel-information-i>
    <ng-content select="aum-panel-actions"></ng-content>
</span>

<span class="aum-expansion-indicator aumico-pattern-icon-arrow-down" *ngIf="_showToggle()">
    <i [@indicatorRotate]="_getExpandedState()"></i>
</span>
